interface Subfolder {
  id: number;
  name: string;
}

interface Folder {
  id: number;
  name: string;
  subfolders: Subfolder[];
}

export interface FoldersObject {
  mandant: Folder[];
  kanzlei: Folder[];
}

interface DataItem {
  id: string;
  name: string;
  type: string;
  children?: DataItem[];
}

export function transformFoldersToHierarchy(
  folders: FoldersObject,
): DataItem[] {
  const result: DataItem[] = [];

  // Process each main section (mandant, kanzlei)
  Object.entries(folders).forEach(([sectionKey, sectionFolders]) => {
    const sectionItem: DataItem = {
      id: sectionKey,
      name: sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1), // Capitalize first letter
      type: "region",
      children: [],
    };

    // Process each folder in the section
    sectionFolders.forEach(
      (folder: { id: any; name: any; subfolders: any[] }) => {
        const folderItem: DataItem = {
          id: `${sectionKey}.${folder.id}`,
          name: folder.name,
          type: "store",
          children: [],
        };

        // Process each subfolder
        folder.subfolders.forEach((subfolder: { id: any; name: any }) => {
          const subfolderItem: DataItem = {
            id: `${sectionKey}.${folder.id}.${subfolder.id}`,
            name: subfolder.name,
            type: "department",
          };

          folderItem.children!.push(subfolderItem);
        });

        // Only add folders if they have subfolders
        if (folderItem.children!.length > 0) {
          sectionItem.children!.push(folderItem);
        }
      },
    );

    // Only add sections if they have folders
    if (sectionItem.children!.length > 0) {
      result.push(sectionItem);
    }
  });

  return result;
}
